exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.featured[data-v-38dd26a0]{position:absolute;top:18px;left:-37px;color:#fff;z-index:10;transform:rotate(-45deg)\n}\n.featured .trapez[data-v-38dd26a0]{border-bottom:40px solid #409EFF;border-left:40px solid transparent;border-right:40px solid transparent;height:0;width:150px\n}\n.featured span[data-v-38dd26a0]{position:absolute;top:8px;right:32px;font-size:16px;font-weight:500\n}\n", ""]);

// exports
